import { render } from "./CartaoMatricula.vue?vue&type=template&id=dc457a34"
import script from "./CartaoMatricula.vue?vue&type=script&lang=js"
export * from "./CartaoMatricula.vue?vue&type=script&lang=js"

import "./CartaoMatricula.vue?vue&type=style&index=0&id=dc457a34&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__